import PromotionChallengeDetailPage from './PromotionChallengeDetailPage'
import { withPromotionChallengeDetailPage } from './withPromotionChallengeDetailPage'

const ConnectedPromotionChallengeDetailPage = withPromotionChallengeDetailPage(
  PromotionChallengeDetailPage
)

export { ConnectedPromotionChallengeDetailPage as PromotionChallengeDetailPage }
